"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Status = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
exports.Status = function (_a) {
    var s = _a.s;
    if (s.id === 1) {
        return react_1["default"].createElement(core_1.Chip, { color: "primary", label: s.name });
    }
    return react_1["default"].createElement(core_1.Chip, { color: "secondary", label: s.name });
};
